module.exports = __webpack_public_path__ + "static/media/GNB_03_search_action.7c8c8d1c.svg";